import { Dispatch } from 'react'
import { ActionCreateErrorState } from './types'

export const createSetErrorAction =
  (dispatch: Dispatch<ActionCreateErrorState>) =>
  (error: { error: boolean; errorMessage?: string }) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  }
